export const ID63 = () => {
    return (
        <div className="section__tab" id="naznachenie_i_funktsionalnye_vozmozhnosti" >
            <div className="about-card__title">
                Назначение и функциональные возможности
            </div>
            <p>
                <strong>Прикладное решение «1С-Рейтинг: Комплексное управление финансами и бюджетирование для
                    Казахстана» предназначено для комплексной автоматизации бухгалтерского и налогового учета,
                    управления финансами и бюджетирования, расчета зарплаты любой сложности и кадрового учета
                    предприятий, осуществляющих любые виды коммерческой деятельности. </strong>
            </p>
            <p>
                Программный продукт будет наиболее эффективен:
            </p>
            <ul>
                <li>на предприятиях, использующих для ведения учета два типовых решения «<a
                    href="/programs/1c/view.php?id=32641" title="Описание и стоимость 1С: Бухгалтерии для Казахстана"
                    target="_self">Бухгалтерия для Казахстана</a>» (бухгалтерский и налоговый учет) и «<a
                    href="/programs/1c/view.php?id=32643"
                    title="Описание и стоимость 1С: Зарплата и управление персоналом для Казахстана" target="_self">Зарплата
                    и Управление персоналом для Казахстана</a>» (расчет зарплаты и кадровый учет). Применение
                    прикладного решения «1С-Рейтинг: Комплексное управление финансами и бюджетирование для Казахстана»
                    на таких предприятиях позволит исключить необходимость дублирования информации (банковские и
                    кассовые документы, справочники и т.д.) и обмена данными между двумя информационными базами;
                </li>
            </ul>
            <ul>
                <li>на предприятиях, заинтересованных в оперативном управлении финансовыми потоками и финансовом
                    планировании. Используя прикладное решение «1С-Рейтинг: Комплексное управление финансами и
                    бюджетирование для Казахстана», предприятие получает инструменты планирования денежных средств и
                    финансового состояния, составления мастер-бюджетов (бюджет доходов и расходов, бюджет движения
                    денежных средств, прогнозный баланс) и других оборотных бюджетов, анализа отклонений плановых и
                    фактических данных.
                </li>
            </ul>
            <p>
                С помощью конфигурации «1С-Рейтинг: Комплексное управление финансами и бюджетирование для Казахстана»
                предприятие может автоматизировать следующие процессы:
            </p>
            <ul>
                <li>регламентированный учет (бухгалтерский и налоговый учет);</li>
                <li>финансовое планирование (бюджетирование и отражение фактических данных в бюджетах);</li>
                <li>оперативное управление денежными средствами (казначейство);</li>
                <li>расчет заработной платы и управление персоналом;</li>
                <li>групповое согласование и утверждение документов;</li>
                <li>учет договоров.</li>
            </ul>
            <br/>
            <div align="center">
                <a href="/sol/imgs/cufib/cufib01.jpg"
                   title="Нажмите, чтобы увеличить изображение" className="screen01"><img width="480"
                                                                                          alt="КУФИБ подсистемы финансовое планирование"
                                                                                          src="/sol/imgs/cufib/cufib01-l.jpg"
                                                                                          height="223"

                                                                                          title="Функциональные возможности"/></a>
            </div>
            <br/>
            <p>
                Функциональные возможности подсистем бухгалтерского и налогового учета, расчета заработной платы и
                управления персоналом аналогичны возможностям типовых решений «Бухгалтерия для Казахстана» и «Зарплата и
                Управление персоналом для Казахстана», а также дополнены функциями, необходимыми для эффективного
                взаимодействия перечисленных подсистем, в том числе расширенными возможностями разграничения прав
                доступа пользователей к информации для обеспечения максимальной конфиденциальности хранящихся в
                информационной базе сведений.
            </p>
            <p>
                <b>Управленческий контур прикладного решения включает следующие подсистемы:</b>
            </p>
            <br/>
            <p>
                <span ><b>Подсистема «Бюджетирование»</b></span> реализует функции, необходимые
                для построения системы финансового управления на предприятии:
            </p>
            <ul>
                <li>постановка системы бюджетирования в целом для предприятия или холдинга;</li>
            </ul>
            <ul>
                <li>возможность сценарного планирования бюджетов - параллельного планирования бюджетов с различными
                    вариантами развития событий, различной структурой бюджетного периода и горизонтом планирования,
                    также возможность сценарного планирования с применением моделирования курса валют;
                </li>
            </ul>
            <ul>
                <li>пакетное создание бюджетов путем копирования бюджетов других периодов или сценариев с применением
                    поправочных коэффициентов на все, либо выбранные статьи формируемого бюджета;
                </li>
            </ul>
            <ul>
                <li>формирование бюджетного регламента, гибкая настройка схем автоматического получения сводных и
                    консолидированных бюджетов различными способами;
                </li>
            </ul>
            <ul>
                <li>календарное планирование исполнения и контроля исполнения задач пользователей в рамках процесса
                    бюджетирования;
                </li>
            </ul>
            <ul>
                <li>упрощение работы пользователя по вводу плановых показателей - настройка различного рода зависимостей
                    между статьями бюджета или различных бюджетов и настройка моделей расчета для отдельных статей (как
                    на основании других плановых данных, так и на основании данных регламентированного учета – например,
                    остатков товаров или денежных средств и т.д.), автоматическое выполнение расчетов на основании
                    установленных зависимостей и моделей;
                </li>
            </ul>
            <ul>
                <li>раздельное формирование бюджетов подразделений и проектов, с возможностью автоматического
                    объединения в сводные и консолидированные бюджеты;
                </li>
            </ul>
            <ul>
                <li>планирование бюджетов предприятия в натуральных и суммовых показателях, с применением различной
                    детализации по измерениям бюджетирования (дополнительной аналитики) – центрам ответственности,
                    проектам, контрагентам и номенклатурным позициям. Предусмотрена возможность определить до десяти
                    дополнительных разрезов, ссылающихся на выбранную пользователем справочную информацию;
                </li>
            </ul>
            <ul>
                <li>поддержка схем планирования бюджетов «сверху-вниз» и «снизу-вверх»;</li>
            </ul>
            <ul>
                <li>подача заявок от подразделений на формирование бюджетов и автоматизированное формирование бюджетов
                    на основании поданных заявок;
                </li>
            </ul>
            <ul>
                <li>корректировка бюджетов, поддержка версионности корректируемых бюджетов;</li>
            </ul>
            <ul>
                <li>настраиваемые формы печати и отчетности по бюджетам (в т.ч. на нескольких языках);</li>
            </ul>
            <ul>
                <li>установка лимитов (контрольных границ) – целевых (для анализа превышений в отчетности) и
                    ограничивающих (для недопущения формирования плановых или фактических операций сверх лимита). В
                    качестве лимитов могут использоваться сформированные бюджеты определенного сценария планирования;
                </li>
            </ul>
            <ul>
                <li>возможность планирования остаточных показателей (в том числе и для преемственности бюджетов
                    следующих периодов) и ведения управленческого учета на предприятии на основании управленческого
                    плана счетов, структура которого может определяться пользователем для собственных нужд;
                </li>
            </ul>
            <ul>
                <li>мониторинг фактической деятельности предприятия в тех же разрезах, в которых проводилось
                    планирование;
                </li>
            </ul>
            <ul>
                <li>полностью настраиваемые схемы отражения фактических данных в бюджетах предприятия и на счетах
                    управленческого плана счетов предоставляют предприятию возможность постановки финансового
                    (управленческого) учета и контроля фактических данных в соответствии с собственными потребностями;
                </li>
            </ul>
            <ul>
                <li>возможность контроля фактически отражаемых операций на основании заложенных в бюджетах предприятия
                    показателей;
                </li>
            </ul>
            <ul>
                <li>составление сводной отчетности по результатам мониторинга;</li>
            </ul>
            <ul>
                <li>контроль соответствия заявок на расходование средств бюджету на период;</li>
            </ul>
            <ul>
                <li>финансовый анализ, самостоятельная настройка выполнения финансовых анализов и финансовых расчетов в
                    соответствии с требованиями предприятия;
                </li>
            </ul>
            <ul>
                <li>анализ доступности денежных средств;</li>
            </ul>
            <ul>
                <li>анализ отклонений плановых и фактических данных, сценарный анализ данных бюджетирования;</li>
            </ul>
            <ul>
                <li>отчетность по управленческому плану счетов.</li>
            </ul>
            <br/>
            <p>
                <span><b>Подсистема «Управление денежными средствами»</b></span> выполняет
                следующие функции, необходимые для эффективного управления движением денежных средств на предприятии,
                контроля над осуществляемыми платежами:
            </p>
            <ul>
                <li>многовалютный учет движения и остатков денежных средств;</li>
            </ul>
            <ul>
                <li>регистрацию планируемых поступлений и расходов денежных средств;</li>
            </ul>
            <ul>
                <li>резервирование денежных средств под предстоящие платежи на расчетных счетах и в кассах;</li>
            </ul>
            <ul>
                <li>размещение денежных средств в ожидаемых входящих платежах;</li>
            </ul>
            <ul>
                <li>формирование платежного календаря;</li>
            </ul>
            <ul>
                <li>возможность разнесения (ручного или автоматического) суммы платежного документа по нескольким
                    договорам и сделкам.
                </li>
            </ul>
            <br/>
            <p>
                <b><span >Подсистема «Учет договоров»</span> </b>предоставляет следующие
                возможности:
            </p>
            <ul>
                <li>регистрация произвольного перечня условий договоров;</li>
            </ul>
            <ul>
                <li>корректировка условий договоров;</li>
            </ul>
            <ul>
                <li>учет товарных операций: договоры с поставщиками и покупателями;</li>
            </ul>
            <ul>
                <li>учет нетоварных операций: входящие и исходящие обязательства;</li>
            </ul>
            <ul>
                <li>регистрация спецификации (номенклатурного состава с указанием цен и количества) для товарных
                    договоров;
                </li>
            </ul>
            <ul>
                <li>учет исполнения товарных договоров при оформлении бухгалтерских документов по ним;</li>
            </ul>
            <ul>
                <li>учет платежей и поступлений по договорам – разовых, регулярных, по графику;</li>
            </ul>
            <ul>
                <li>расчет размера платежей различным образом – по фиксированной заложенной сумме, по
                    фактической/плановой задолженности и т.д.;
                </li>
            </ul>
            <ul>
                <li>расчет пени по просрочкам платежей;</li>
            </ul>
            <ul>
                <li>регистрация различных событий по договорам;</li>
            </ul>
            <ul>
                <li>возможность отсчета платежей по графику от даты наступления события по договору;</li>
            </ul>
            <ul>
                <li>связь с подсистемой казначейства через формирование заявок на расходование и оформление плановых
                    поступлений денежных средств на основании ожидаемых платежей по договорам;
                </li>
            </ul>
            <ul>
                <li> возможна настройка маршрутов утверждения договоров в подсистеме «Управление согласованием и
                    утверждением документов»/
                </li>
            </ul>
            <br/>
            <p>
                <span
                    ><b>Подсистема «Управление согласованием и утверждением документов»</b></span> предоставляет
                возможность создания маршрутов согласования и утверждения документов для совместной работы и контроля
                отдельных хозяйственных операций. Доступны следующие возможности:
            </p>
            <ul>
                <li>настройка маршрутов для определенного перечня документов;</li>
            </ul>
            <ul>
                <li>назначение для одного вида документов нескольких маршрутов, применяемых в зависимости от условий
                    использования и вычисляемых применительно к конкретному экземпляру – документу;
                </li>
            </ul>
            <ul>
                <li>произвольное создание точек маршрута – этапов;</li>
            </ul>
            <ul>
                <li>назначение прав подписи отдельным пользователям, либо группам пользователей, по этапам маршрутов;
                </li>
            </ul>
            <ul>
                <li>настройка контроля и автоматического заполнения отдельных реквизитов первичных документов при
                    прохождении этапов согласования и утверждения;
                </li>
            </ul>
            <ul>
                <li>формирование списка задач исполнителям;</li>
            </ul>
            <ul>
                <li>отчетность по состоянию документов на маршрутах;</li>
            </ul>
            <ul>
                <li>формирование карт маршрутов и карт движения документов по маршрутам;</li>
            </ul>
            <ul>
                <li>мониторинг состояния выбранных документов – постановка на контроль;</li>
            </ul>
            <ul>
                <li>мониторинг состояния отдельных документов из формы списка документов и из формы документа, вывод
                    сведений о собранных подписях;
                </li>
            </ul>
            <ul>
                <li>настройка условного использования отдельных этапов маршрута;</li>
            </ul>
            <ul>
                <li>возможность выполнения автоматических действий на этапах маршрута в зависимости от выполнения
                    условий по документу – автоматическое утверждение, отклонение или возврат документа на пересмотр для
                    более эффективного использования времени кадровых ресурсов предприятия;
                </li>
            </ul>
            <ul>
                <li>защита от изменения согласуемых документов.</li>
            </ul>
            <p>
                Поскольку прикладное решение включает в себя возможности ведения бухгалтерского и налогового учета,
                полноценного учета кадров предприятия и расчета заработной платы, то одним из наиболее актуальных
                является вопрос гибкого разграничения прав доступа между пользователями системы, в том числе ограничение
                доступа к сведениям по заработной плате. В связи с этим, в прикладном решении предусмотрен большой набор
                ролей, достаточно автономных и позволяющих модульно назначать каждому пользователю только те функции, к
                которым он должен иметь доступ.
            </p>
            <p>
                Помимо этого, работа с данными по заработной плате – ее расчету и выплате – максимально отделена от
                работы с прочими данными бухгалтерского учета. Предусмотрена возможность сводного отражения в
                бухгалтерском учете расчетов по заработной плате, благодаря чему обеспечивается доступность детальных
                данных по заработной плате только тем лицам, которые имеют на нее право.
            </p>
            <p>
                Программный продукт «1С-Рейтинг: Комплексное управление финансами и бюджетирование для Казахстана» не
                является самостоятельным, для его работы необходимо наличие типовых конфигураций «Бухгалтерия для
                Казахстана» и «Зарплата и Управление персоналом для Казахстана» системы программ «1С:Предприятие 8».
            </p>
        </div>
    )
}